import { useQuery } from '@tanstack/react-query';
import { pagesService } from '../services/pagesService';
import { queryKeys } from '../api/queryClient';
import { useAuth } from './useAuth';

export function useAdminDashboard() {
  const { applyViewer } = useAuth();
  const query = useQuery({
    queryKey: queryKeys.adminDashboard(),
    queryFn: async () => {
      const data = await pagesService.adminDashboard();
      if (data?.viewer) applyViewer(data.viewer);
      return data;
    },
  });

  return {
    data: query.data ?? null,
    loading: query.isLoading,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : 'Failed to load'
      : null,
  };
}
